<script>
	import { userData } from '../../js/stores';
	import { push } from 'svelte-spa-router';
	import updateUserData from '../../js/updateUserData';
	import { API_URL } from '../../../env';

	// Logout
	async function logout() {
		const res = await fetch(API_URL + '/users/logout', {
			method: 'PUT',
			credentials: 'include'
		});

		if (!res.ok) {
			return addAlert("danger", "Chyba", 'Odhlásenie sa nepodarilo. Skúste to prosím znova.');
		}

		await updateUserData();

		await push('/');
	}
</script>

<div class="account-header">
	<div class="row">
		<div class="col-md-6 col-lg-5 col-xl-5">
			<div class="header-left">
				<div class="account-image">
					<img src="assets/img/icons/pneuin_ikona_cierna.svg" alt="Logo PNEUIN.sk">
				</div>
				<div class="account-name">
					<h1>
						{#if $userData?.name}
							{$userData.name + " " + ($userData.surname || "")}
						{:else}
							{$userData?.email}
						{/if}
					</h1>
					<button type="button" on:click={logout}>Odhlásiť sa</button>
				</div>
			</div>
		</div>
		<div class="col-md-6 col-lg-5 col-xl-4 offset-lg-2 offset-xl-3 d-none d-md-block">
			<div class="header-right">
				<div class="account-icon">
					<i class="fat fa-fw fa-comment-question"></i>
				</div>
				<div class="account-questions">
					<span>Kontaktujte nás</span>
					<p class="mb-3"><a href="mailto:info@pneuin.sk">info@pneuin.sk</a></p>
					<p><span>Pon - Pia</span> 8:00 - 17:00</p>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
  .account-header {
    border: 1px solid var(--color-slate-200);
    background-color: var(--color-slate-50);
    border-radius: 1.5rem;
    padding: 1.75rem;
    margin-bottom: 1.75rem;
  }
  .account-header .header-left {
    display: flex;
    flex-direction: row;
    place-items: center;
  }
  .account-header .header-left h1 {
    text-transform: uppercase;
    font-family: Rubik, sans-serif;
    font-weight: 600;
    color: var(--color-slate-900);
  }
  .account-header .header-left button {
    padding: 0;
    color: var(--color-slate-500);
    cursor: pointer;
    font-size: 1rem;
    margin-top: .25rem;
  }
  .account-header .header-left button:hover {
    text-decoration: underline;
  }
  .account-header .header-left .account-image {
    width: 5rem;
    height: 5rem;
    background-color: var(--color-slate-200);
    border-radius: 50%;
    padding: 1rem;
    margin-right: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .account-header .header-left .account-image img {
    height: 3rem;
    width: 3rem;
    filter: opacity(0.5);
  }
  .account-header .header-right {
    display: flex;
    place-items: center;
    justify-content: right;
  }
  .account-header .header-right i {
    font-size: 3.5rem;
    color: var(--color-slate-300);
  }
  .account-header .header-right .account-questions {
    border-left: 1px solid var(--color-slate-200);
    padding-left: 1.5rem;
    margin-left: 1.25rem;
  }
  .account-header .header-right .account-questions span {
    font-family: Rubik, sans-serif;
    font-weight: 600;
    color: var(--color-slate-900);
    margin-bottom: .25rem;
  }
  .account-header a,
  .account-header .header-right .account-questions a {
    cursor: pointer;
    color: var(--color-slate-500);
  }
  .account-header a:hover,
  .account-header .header-right .account-questions a:hover {
    text-decoration: underline;
  }
  .account-header .header-right .account-questions p,
  .account-header .header-right .account-questions a {
    color: var(--color-slate-500);
  }
</style>